import { z } from 'zod';

export const SignatureConfigSchema = z.object({
  id: z.number(),
  ambitoId: z.number(),
  tipoOtId: z.number().nullable(),
  pageNumber: z.number().int().positive(),
  xCoord: z.number(),
  yCoord: z.number(),
  width: z.number().positive(),
  height: z.number().positive(),
  label: z.string(),
  activo: z.boolean(),
});

export const CreateSignatureConfigSchema = z.object({
  ambitoId: z.number().int().positive(),
  tipoOtId: z.number().int().positive().optional(),
  pageNumber: z.number().int().positive().default(1),
  xCoord: z.number(),
  yCoord: z.number(),
  width: z.number().positive().default(150),
  height: z.number().positive().default(50),
  label: z.string().default('Firma Supervisor'),
});

export const GeneratePdfSchema = z.object({
  ticketId: z.number().int().positive(),
});

export const StampSignatureSchema = z.object({
  ticketId: z.number().int().positive(),
  signatureS3Key: z.string().min(1),
});

export type SignatureConfig = z.infer<typeof SignatureConfigSchema>;
export type CreateSignatureConfigInput = z.infer<typeof CreateSignatureConfigSchema>;
export type GeneratePdfInput = z.infer<typeof GeneratePdfSchema>;
export type StampSignatureInput = z.infer<typeof StampSignatureSchema>;
